// src/services/analyticsService.js

import { 
  collection, 
  addDoc, 
  serverTimestamp,
  query,
  where,
  getDocs,
  orderBy
} from 'firebase/firestore';
import { db } from '../config/firebase';

class AnalyticsService {
  async trackCustomDomainVisit(bookId, bookData, additionalData = {}) {
    try {
      const domain = window.location.hostname;
      const isCustomDomain = !domain.includes('localhost') && 
                           !domain.includes('127.0.0.1') &&
                           !domain.includes('firebase') && 
                           domain !== 'parrotpages.co.za' &&
                           !domain.includes('web.app') &&
                           !domain.includes('firebaseapp.com');

      if (!isCustomDomain) return;

      const visitorId = this.getOrCreateVisitorId();
      const sessionId = this.getOrCreateSessionId();
      const now = new Date();
      
      const visitData = {
        bookId,
        domain: bookData.customDomain || domain,
        templateType: bookData.templateType,
        visitorId,
        sessionId,
        timestamp: serverTimestamp(),
        date: now.toISOString().split('T')[0],
        url: window.location.href,
        referrer: document.referrer || 'direct',
        userAgent: navigator.userAgent,
        screenSize: `${window.screen.width}x${window.screen.height}`,
        language: navigator.language,
        ...additionalData
      };

      await addDoc(collection(db, 'pb-analytics-visits'), visitData);
      console.log('📊 Visit tracked');
    } catch (error) {
      console.error('❌ Error tracking visit:', error);
    }
  }

  async getBookAnalytics(bookId, days = 30) {
    try {
      const endDate = new Date();
      const startDate = new Date(endDate.getTime() - days * 24 * 60 * 60 * 1000);
      const startDateStr = startDate.toISOString().split('T')[0];
      
      const visitsQuery = query(
        collection(db, 'pb-analytics-visits'),
        where('bookId', '==', bookId),
        where('date', '>=', startDateStr),
        orderBy('date', 'desc')
      );
      
      const snapshot = await getDocs(visitsQuery);
      const visits = snapshot.docs.map(doc => doc.data());
      
      // Calculate stats
      const uniqueVisitors = new Set(visits.map(v => v.visitorId)).size;
      const dailyVisits = {};
      
      visits.forEach(visit => {
        dailyVisits[visit.date] = (dailyVisits[visit.date] || 0) + 1;
      });
      
      return {
        totalVisits: visits.length,
        uniqueVisitors,
        dailyVisits,
        visits: visits.slice(0, 100) // Latest 100
      };
    } catch (error) {
      console.error('❌ Error getting analytics:', error);
      return null;
    }
  }

  getOrCreateVisitorId() {
    let visitorId = localStorage.getItem('pp_visitor_id');
    if (!visitorId) {
      visitorId = `v_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
      localStorage.setItem('pp_visitor_id', visitorId);
    }
    return visitorId;
  }

  getOrCreateSessionId() {
    let sessionId = sessionStorage.getItem('pp_session_id');
    if (!sessionId) {
      sessionId = `s_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
      sessionStorage.setItem('pp_session_id', sessionId);
    }
    return sessionId;
  }
}

export const analyticsService = new AnalyticsService();